import React from 'react';

// A choice inside a sentence ("Bravo prepares the draft invoices [automatically, every morning]."): a native select
// in bold navy, as wide as its longest choice. options are { value, label }; onChange gets the picked option's own
// value, so a number or null stays one. label names the choice for screen readers, as the sentence around it does
// for everyone else.
export default function InlineSelect({
  value = null,
  options = [],
  label = '',
  disabled = false,
  onChange = (newValue) => {},
}) {
  function pick(pickedText) {
    const pickedOption = options.find((option) => optionText(option.value) === pickedText);
    onChange(pickedOption ? pickedOption.value : pickedText);
  }

  return (
    <select
      className='ds-pick'
      aria-label={label}
      value={optionText(value)}
      disabled={disabled}
      onChange={(e) => pick(e.target.value)}
    >
      {options.map((option) => (
        <option
          key={optionText(option.value)}
          value={optionText(option.value)}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}

// A select holds text, so an option's value is compared and stored as text; null and undefined become ''.
function optionText(optionValue) {
  return optionValue === null || optionValue === undefined ? '' : String(optionValue);
}
